import React from 'react';
import { withRouter } from 'react-router-dom';

export default withRouter(
class ToolbarComponent extends React.Component {
    goBack = () => this.props.history.goBack();

    render() {
        return (
            <div className="navbar">
                <div className="navbar-brand">
                    <div className="navbar-item">
                        <h1>{this.props.title}</h1>
                    </div>
                </div>
                <div className="navbar-menu is-active">
                    <div className="navbar-item">
                        <a onClick={this.goBack}>
                            <i className="fas fa-arrow-left"></i> Atras
                        </a>
                    </div>
                </div>
            </div>
        );
    }
})


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/registers/scenes/patient-details/components/toolbar/index.js